import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PaintBrush, PencilSimple, Plus } from "@phosphor-icons/react";
import { ThankYouPreviewDialog } from "@/components/thankyou/ThankYouPreviewDialog";
import { BuildPagesDialog } from "@/components/landers/BuildPagesDialog";

const BTN = "border-2 border-black bg-white px-2 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 transition-colors duration-100 hover:bg-black hover:text-white";

// A buyer's page set: its thank-you layout (preview + switch), the page editor, and adding another landing page.
export function BuyerPageActions({ page, onChanged }) {
  const [open, setOpen] = useState("");
  const p = `buyer-page-actions-${page.code}`;
  const ty = page.ty_design || {};
  const b = { id: page.page_id, code: page.code, firm_name: page.firm_name, picks: page.picks, ty_design: page.ty_design, is_draft: false };
  const close = () => setOpen("");
  return (
    <div className="flex w-full flex-wrap items-center gap-1.5 border-t border-zinc-300 pt-2" data-testid={p}>
      <span className="mr-1 text-[10.5px]" data-testid={`${p}-layout`}>
        Thank-you layout: <b>{ty.name || "Classic"}</b>{ty.is_default ? " (site default)" : ""}
      </span>
      <button type="button" onClick={() => setOpen("layout")} className={BTN} data-testid={`${p}-switch-layout`}>
        <PaintBrush size={11} weight="bold" /> Preview / switch layout
      </button>
      <Link to={`/admin/landing-pages/custom/${page.page_id}`} className={BTN} data-testid={`${p}-edit`}>
        <PencilSimple size={11} weight="bold" /> Edit buyer page
      </Link>
      <button type="button" onClick={() => setOpen("add")} className={BTN} data-testid={`${p}-add-page`}>
        <Plus size={11} weight="bold" /> Add a landing page
      </button>
      {open === "layout" && <ThankYouPreviewDialog b={b} onClose={close} onSaved={onChanged} />}
      {open === "add" && <BuildPagesDialog b={b} onClose={close} onBuilt={onChanged} />}
    </div>
  );
}
